const $             = require('jquery');
const qs            = require('query-string');
const endpoint      = require('@readcube/endpoint');
const user          = require('../user');
const receiver      = require('../util/receiver');
const Modal         = require('../ctrl/modal');

const api = {};

function login({
  syncApi,
  trackingAction,
  trackingOrigin = 'web'
}) {
  return new Promise(resolve => {
    if (user.signedIn) {
      resolve();
      return;
    }

    let src = `${endpoint.web}/authentication`;
    let params = {
      embed: 1,
      client: 'web_reader'
    };

    if (trackingAction) {
      Object.assign(params, {
        tracking_action: trackingAction,
        tracking_origin: trackingOrigin
      });
    }

    src = `${src}?${qs.stringify(params)}`

    let elem = $(`
      <div class="auth-container">
        <iframe class="auth-frame" src="${src}"></iframe>
        <div class="loader"></div>
      </div>
    `);

    elem.find('iframe').on('load', hideLoader);
    receiver.readcube.on('auth:new', hideLoader);
    receiver.readcube.on('auth:success', (e, { auth }) => {
      syncApi.user.reader().then(data => user.set(data, auth));
    });

    openModal();

    function hideLoader() {
      elem.addClass('loaded');
    }

    function openModal() {
      let modal = Modal({
        css_class: 'auth-modal',
        content: elem
      });

      user.one('auth', () => {
        modal.close();
        resolve();
      });

      modal.open();
    }
  });
}

api.login = login;

module.exports = api;
